import { Button, InfoBox, ModalTitle } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledModalTitle = styled(ModalTitle)`
  margin-bottom: -1rem;
  gap: 1.4rem;
  display: flex;
  align-items: center;
`;

export const StyledTextField = styled.div`
  margin-top: 2rem;
  label {
    margin-bottom: 0.9rem;
  }
`;

export const StyledButton = styled(Button)`
  text-wrap: nowrap;
  background-color: ${({ theme }) => theme.colors.button.close.background};
`;

export const StyledButtonTitle = styled.p`
  padding-left: 0rem;
`;

export const StyledInfoBox = styled(InfoBox)`
  margin-top: 1rem;
`;
